export default function Terms() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16" data-testid="terms-page">
      <div className="overline" style={{ color: "var(--terracotta)" }}>Legal</div>
      <h1 className="font-serif text-5xl mt-2">Terms of Service</h1>
      <p className="mt-3 text-xs" style={{ color: "var(--ink-soft)" }}>Last updated: {new Date().toLocaleDateString()}</p>

      <div className="mt-10 space-y-8 text-sm leading-relaxed" style={{ color: "var(--ink-soft)" }}>
        <section>
          <h2 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>1. What AddVendTour is</h2>
          <p className="mt-2">
            AddVendTour is a marketplace that helps independent vendors (“makers”) discover local events and helps
            event organizers (“hosts”) find vendors to fill their events. We are a platform. We are not the event
            organizer, we are not the vendor, and we do not run any event ourselves unless we explicitly say so.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>2. Not responsible for events, cancellations, or outcomes</h2>
          <p className="mt-2">
            We are not responsible for canceled events as we are not associated with any event organizer unless
            stated. We are not responsible for any scammers that may slip through our procedural checks or bad event
            turn outs. All communication, deliverables, refunds and disputes between vendors and organizers are the
            responsibility of those parties.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>3. Accounts, signup fees, and payments</h2>
          <p className="mt-2">
            Makers pay a one-time signup fee of $19 to activate their account; hosts pay $49. Booth fees are set by
            each organizer and are collected on their behalf via Stripe. All fees are non-refundable except where
            required by law. Charge-backs may result in immediate suspension.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>4. Acceptable use</h2>
          <p className="mt-2">
            You agree not to misrepresent your business, post illegal or infringing content, harass other users, or
            attempt to reverse-engineer the service. We may remove content or accounts at our discretion.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>5. Limitation of liability</h2>
          <p className="mt-2">
            To the maximum extent permitted by law, AddVendTour&apos;s total liability for any claim arising from your use
            of the service is limited to the fees you paid us in the twelve months preceding the claim.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl" style={{ color: "var(--ink)" }}>6. Contact</h2>
          <p className="mt-2">
            Questions? Email <a className="underline" href="mailto:hello@addvendtour.com">hello@addvendtour.com</a>.
          </p>
        </section>

        <p className="text-xs italic pt-8" style={{ color: "var(--ink-soft)" }}>
          Please have counsel review before public launch.
        </p>
      </div>
    </div>
  );
}
